import { useState } from "react";
import { Play } from "lucide-react";

const VIDEO_ID = "GMNcecZ7T0M";

const DiscoverVideo = () => {
  const [play, setPlay] = useState(false);

  return (
    <section
      data-testid="discover-video-section"
      className="py-20 bg-[var(--ac-navy)] text-white relative overflow-hidden"
    >
      <div className="ac-container">
        <div className="text-center mb-10">
          <div className="eyebrow on-dark">In 60 Seconds</div>
          <h2
            className="section-heading on-dark mt-3"
            data-testid="discover-video-heading"
          >
            Discover Anderson
          </h2>
        </div>

        <div
          className="relative max-w-4xl mx-auto aspect-video rounded-2xl overflow-hidden shadow-[0_50px_80px_-40px_rgba(0,0,0,0.6)] border border-white/10"
          data-testid="discover-video-frame"
        >
          {play ? (
            <iframe
              src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
              title="Anderson College: 140 Years of Career Training Excellence"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            />
          ) : (
            <button
              onClick={() => setPlay(true)}
              className="w-full h-full block relative group"
              aria-label="Play Anderson College video"
              data-testid="discover-video-play"
            >
              <img
                src={`https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                alt="Anderson College video thumbnail"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-all flex items-center justify-center">
                <div className="w-20 h-20 rounded-full bg-[var(--ac-red)] flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
                  <Play className="w-8 h-8 text-white ml-1" fill="currentColor" />
                </div>
              </div>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default DiscoverVideo;
